import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';
import { CustomerPreferences } from 'src/app/models/preferences.model';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PreferencesService {

	private baseProposalUrl = `${environment.baseUrl}/preference`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getCustomerUsers(token: string): Observable<UserContactInfo[]> {
		return this.httpClient.get<UserContactInfo[]>(`${this.baseProposalUrl}/${token}/customer-users`);
	}

	@ApiMethod()
	getPreferences(token: string): Observable<CustomerPreferences> {
		return this.httpClient.get<CustomerPreferences>(`${this.baseProposalUrl}/${token}`);
	}

	@ApiMethod()
	setPreferences(token: string, preferences: CustomerPreferences): Observable<void> {
		return this.httpClient.post<void>(`${this.baseProposalUrl}/${token}`, preferences);
	}
}
